import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const SidebarMenu = ({ route, isOpen }) => {
  const location = useLocation();

  // Helper function: Checks if the path is an exact match OR if we are inside a nested route (e.g. /offers/edit/1)
  const isPathActive = (subPath) => {
    if (subPath === "/") {
      return location.pathname === "/"; 
    }
    return location.pathname === subPath || location.pathname.startsWith(`${subPath}/`);
  };

  // Determine if the current route (or any nested edit/create route) is active
  const isChildActive = route.subRoutes.some((sub) => isPathActive(sub.path));

  // Parent menu should be open if:
  // 1. It's the "Catalog" (always open)
  // 2. Any child route is active
  const isCatalog = route.name.toLowerCase() === "catalog";
  const [open, setOpen] = useState(isCatalog || isChildActive);

  // Update open state whenever location changes
  useEffect(() => {
    if (!isCatalog) {
      setOpen(isChildActive);
    }
  }, [location.pathname, isCatalog, isChildActive]);

  return (
    <div>
      {/* Parent Menu */}
      <div
        className="sidebar-parent d-flex align-items-center justify-content-between"
        onClick={() => setOpen(!open)}
        style={{ cursor: "pointer", padding: "10px" }}
      >
        <div className="d-flex align-items-center gap-2">
          <span>{route.icon}</span>
          {isOpen && <span>{route.name}</span>}
        </div>

        {isOpen &&
          (open ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />)}
      </div>

      {/* Sub Menu */}
      <Collapse in={open}>
        <div className="ms-4">
          {route.subRoutes.map((sub, i) => (
            <NavLink
              to={sub.path}
              key={i}
              // Use our custom helper to keep the item highlighted on nested pages
              className={() =>
                isPathActive(sub.path)
                  ? "d-flex gap-3 py-2 sidebar-sub active"
                  : "d-flex gap-3 py-2 sidebar-sub"
              }
            >
              <div className="icon">{sub.icon}</div>
              <div className="link_text">{sub.name}</div>
            </NavLink>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default SidebarMenu;